import {SiteInfo, WixSdk} from '@wix/js-sdk-wrapper';

let _siteInfo: SiteInfo | undefined;

export const getSiteInfo = () => {
  return _siteInfo
    ? Promise.resolve(_siteInfo)
    : WixSdk.getSiteInfo().then((siteInfo) => {
        _siteInfo = siteInfo;

        return siteInfo;
      });
};

// test only
export const resetSiteInfo = () => {
  _siteInfo = undefined;
};
